import { GET_NOTIFICATIONCOUNT_FAILED, GET_NOTIFICATIONCOUNT_REQUESTED, GET_NOTIFICATIONCOUNT_SUCCESS, GET_NOTIFICATIONSEEN_FAILED, GET_NOTIFICATIONSEEN_REQUESTED, GET_NOTIFICATIONSEEN_SUCCESS, GET_NOTIFICATION_FAILED, GET_NOTIFICATION_REQUESTED, GET_NOTIFICATION_SUCCESS } from "resources/actionTypes";

const initialState = {
  userNotification: [],
  loading: false,
  error: null,
};
const initialStateCount = {
  userNotificationCount: [],
  loading: false,
  error: null,
};
const initialStateSeen = {
  userNotificationSeen: [],
  loading: false,
  error: null,
};

export function userNotification(state = initialState, action) {
  switch (action.type) {
    case GET_NOTIFICATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        userNotification: action.userNotification,
      };
    case GET_NOTIFICATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userNotificationCount(state = initialStateCount, action) {
  switch (action.type) {
    case GET_NOTIFICATIONCOUNT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_NOTIFICATIONCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        userNotificationCount: action.userNotificationCount,
      };
    case GET_NOTIFICATIONCOUNT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userNotificationSeen(state = initialStateSeen, action) {
  switch (action.type) {
    case GET_NOTIFICATIONSEEN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_NOTIFICATIONSEEN_SUCCESS:
      return {
        ...state,
        loading: false,
        userNotificationSeen: action.userNotificationSeen,
      };
    case GET_NOTIFICATIONSEEN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}